(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.EmailMarketing",
                    {
                        url: "/EmailMarketing/{year}&{monthId}",
                        component: "emailMarketing",
                        PageTitle: "Email Marketing | Marketing Tracker"
                    });
        }
    ]);

    app.component("emailMarketing",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/EmailMarketing/email-marketing-template.html",
            controller: emailMarketingController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    emailMarketingController.$inject = ["figToaster", "marketingTrackerEmailMarketingApi", "$q", "$stateParams", "$timeout"];
    function emailMarketingController(figToaster, marketingTrackerEmailMarketingApi, $q, $stateParams, $timeout) {

        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    isLoading: {
                        messages: false,
                        monthlyPerformance: false
                    }
                },
                charts: {
                    chart0: {},
                    chart1: {}
                },
                currentDate: moment(),
                emailMarketing: { AverageOpenRate: 0, AverageClickRate: 0 },
                months: [
                    { Name: 'January', Id: 1 },
                    { Name: 'February', Id: 2 },
                    { Name: 'March', Id: 3 },
                    { Name: 'April', Id: 4 },
                    { Name: 'May', Id: 5 },
                    { Name: 'June', Id: 6 },
                    { Name: 'July', Id: 7 },
                    { Name: 'August', Id: 8 },
                    { Name: 'September', Id: 9 },
                    { Name: 'October', Id: 10 },
                    { Name: 'November', Id: 11 },
                    { Name: 'December', Id: 12 },
                    { Name: 'All', Id: -1 }
                ],
                monthsData: [],
                resetDate: resetDate,
                selected: [],
                toggleSort: toggleSort,
                years: []
            });

        function resetDate(dateObj) {
            var promises = [];
            promises.push(_getEmailMarketing(dateObj));
            $q.all(promises);
        }

        function _resetFilters(propertyName) {
            $ctrl.propertyName = propertyName || 'Date';
        }


        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function _getEmailMarketing(timeFrame) {
            $ctrl.ui.isLoading.messages = true;
            $ctrl.ui.isLoading.monthlyPerformance = true;

            var endDate = moment().set({ 'year': timeFrame.year }).endOf('year').format(),
                startDate = moment().set({ 'year': timeFrame.year }).startOf('year').format();

            //var endDate = !!timeFrame
            //    ? timeFrame.month.Id === -1
            //        ? moment().set({ 'year': timeFrame.year }).endOf('year').format()
            //        : moment().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id - 1 }).endOf('month').format()
            //    : moment().endOf('month').format(),
            //    startDate = !!timeFrame
            //        ? timeFrame.month.Id === -1
            //            ? moment().set({ 'year': timeFrame.year }).startOf('year').format()
            //            : moment().set({ 'year': timeFrame.year, 'month': timeFrame.month.Id - 1 }).startOf('month').format()
            //        : moment().startOf('month').format();

            var message = "", toastClass = "";
            marketingTrackerEmailMarketingApi.getMetricsByTimeframe(startDate, endDate)
                .then(function (response) {
                    var allMessages = [],
                        monthsMessages = [];
                    $ctrl.emailMarketing = response;
                    _.forEach(response.Metrics, function (messageArray) {
                        allMessages = allMessages.concat(messageArray.Messages);
                        return;
                    });
                    $ctrl.emailMarketing.AllMessages = allMessages;
                    $timeout(function () { _resetEmailChart($ctrl.emailMarketing); })
                        .then(function () {
                            $ctrl.ui.isLoading.monthlyPerformance = false;
                        });
                    if (timeFrame.month.Id !== -1) {
                        _.forEach($ctrl.emailMarketing.AllMessages, function (message) {
                            if (moment(message.Date).month() === timeFrame.month.Id - 1) {
                                monthsMessages = monthsMessages.concat(message);
                            }
                            return;
                        });
                    } else {
                        monthsMessages = $ctrl.emailMarketing.AllMessages;
                    }

                    monthsMessages = _.sortBy(monthsMessages, function (a) {
                        return moment(a.Date).format();
                    });
                    _.forEach(monthsMessages, function (message) {
                        message.Index = monthsMessages.indexOf(message) + 1;
                        return;
                    });
                    $ctrl.emailMarketing.MonthsMessages = monthsMessages;

                    _resetMessagePerformancechart($ctrl.emailMarketing.MonthsMessages);
                })
                .catch(function (error) {
                    console.log("Error: ", error);
                    message = "There was a problem importing your messages. Please try again shortly.";
                    toastClass = "is-error";
                    return figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.ui.isLoading.messages = false;
                    $ctrl.ui.isLoading.monthlyPerformance = false;
                });
        }

        function _resetEmailChart(dataGroup) {
            var dataInfo = [
                dataGroup.Metrics.map(function (a) { return a.AverageOpenRate; }),
                dataGroup.Metrics.map(function (a) { return a.AverageClickRate; })
                //,dataGroup.Metrics.map(function (a) { return a.AverageOptOutRate; })                
            ];
            var dataLabels = $ctrl.months.map(function (a) { return a.Name; }).slice(0, 12);
            var rgbColors = ["122,175,212", "209,135,164"];

            $ctrl.charts.chart0 = {
                labels: dataLabels,
                series: ['Average Opens', 'Average CTR'],
                colors: [{
                    backgroundColor: "rgba(" + rgbColors[0] + ", 0.2)",
                    pointBackgroundColor: "rgba(" + rgbColors[0] + ", 1)",
                    pointHoverBackgroundColor: "rgba(" + rgbColors[0] + ", 0.8)",
                    borderColor: "rgba(" + rgbColors[0] + ", 1)",
                    pointBorderColor: '#fff',
                    pointHoverBorderColor: "rgba(" + rgbColors[0] + ", 1)"
                }, "rgba(" + rgbColors[1] + ",0.5)", "#9a9a9a", "rgb(233,177,69)"],
                data: dataInfo,
                //data: [Object.values(dataInfo[0].Opens), Object.values(dataInfo[0].ClickRates)],
                //onClick: function (points, evt) {
                //    console.log(points, evt);
                //},
                datasetOverride: [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }],
                options: {
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: { beginAtZero: true }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: false,
                                position: 'right',
                                ticks: { beginAtZero: true }
                            }
                        ]
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: { display: true }
                }
            };
        }

        function _resetMessagePerformancechart(dataGroup) {
            var dataInfo = [
                dataGroup.map(function (a) { return a.OpenRate; }),
                dataGroup.map(function (a) { return a.ClickRate; })
                //, dataGroup.AllMessages.map(function (a) { return a.OptOutRate; })
            ];
            var dataLabelsShort = dataGroup.map(function (a) { return _textTruncate(a.Title, 30, '...'); });
            var dataIndexes = dataGroup.map(function (a) { return a.Index; });
            var rgbColors = ["122,175,212", "209,135,164"];

            $ctrl.charts.chart1 = {
                labels: dataIndexes,
                series: ['Opens', 'CTR'],
                colors: [{
                    backgroundColor: "rgba(" + rgbColors[0] + ", 0.2)",
                    pointBackgroundColor: "rgba(" + rgbColors[0] + ", 1)",
                    pointHoverBackgroundColor: "rgba(" + rgbColors[0] + ", 0.8)",
                    borderColor: "rgba(" + rgbColors[0] + ", 1)",
                    pointBorderColor: '#fff',
                    pointHoverBorderColor: "rgba(" + rgbColors[0] + ", 1)"
                }, "rgba(" + rgbColors[1] + ",0.5)", "#9a9a9a", "rgb(233,177,69)"],
                data: dataInfo,
                //onClick: function (points, evt) {
                //    console.log(points, evt);
                //},
                datasetOverride: [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }],
                options: {
                    //layout: {
                    //    padding: {
                    //        left: 10,
                    //        right: 10,
                    //        top: 0,
                    //        bottom: 0
                    //    }
                    //},
                    legend: { display: true },
                    maintainAspectRatio: false,
                    responsive: true,
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: { beginAtZero: true }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: false,
                                position: 'right',
                                ticks: { beginAtZero: true }
                            }
                        ]
                    }
                    ,
                    tooltips: {
                        callbacks: {
                            title: function (obj) {
                                return dataLabelsShort[obj[0].index];
                            }
                        }
                    }
                }
            };
        }

        function _textTruncate(fullString, length, ending) {
            if (length === null) {
                length = 50;
            }
            if (ending === null) {
                ending = '...';
            }
            var strLength = !!fullString ? fullString.length : 0;
            if (strLength > length) {
                return fullString.substring(0, length - ending.length) + ending;
            } else {
                return fullString;
            }
        }
        $ctrl.$onInit = function () {
            for (var i = 2015; i <= $ctrl.currentDate.year(); i++) {
                $ctrl.years.push(i);
            }
            $ctrl.selected.month = !!$stateParams.monthId
                ? _.find($ctrl.months, function (month) { return month.Id === Number($stateParams.monthId); })
                : _.find($ctrl.months, function (month) { return month.Id === -1; });
            $ctrl.selected.year = !!$stateParams.year ? Number($stateParams.year) : _.find($ctrl.years, function (year) { return year === $ctrl.currentDate.year(); });
            _resetFilters('Date');
            resetDate($ctrl.selected);
        };
    }
})(window.app, window.angular); //jshint ignore:line